import { render, staticRenderFns } from "./Review.vue?vue&type=template&id=35390ab0&scoped=true&"
import script from "./Review.vue?vue&type=script&lang=ts&"
export * from "./Review.vue?vue&type=script&lang=ts&"
import style0 from "./Review.vue?vue&type=style&index=0&id=35390ab0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35390ab0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsRatingStarsBar: require('/var/www/packages/theme/components/atoms/RatingStarsBar.vue').default,IconsThumbUpIcon24px: require('/var/www/packages/theme/components/icons/thumb-up/ThumbUpIcon24px.vue').default,AtomsKEButton: require('/var/www/packages/theme/components/atoms/KEButton.vue').default,AtomsFeatureProgressBar: require('/var/www/packages/theme/components/atoms/FeatureProgressBar.vue').default})
